import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "../components/shell/AppShell.jsx";
import { ProtectedRoute } from "../features/auth/ProtectedRoute.jsx";
import { WorkspaceTimeZoneProvider } from "../features/profile/WorkspaceTimeZone.jsx";
import { TodayPage } from "../pages/TodayPage.jsx";

function lazyNamed(loader, exportName) {
  return lazy(async () => {
    const module = await loader();
    return { default: module[exportName] };
  });
}

const AnalyticsPage = lazyNamed(
  () => import("../features/analytics/AnalyticsPage.jsx"),
  "AnalyticsPage",
);
const AuthFinishPage = lazyNamed(
  () => import("../features/auth/AuthFinishPage.jsx"),
  "AuthFinishPage",
);
const BillingPlanPage = lazyNamed(
  () => import("../features/billing/BillingPlanPage.jsx"),
  "BillingPlanPage",
);
const CrmPage = lazyNamed(() => import("../features/crm/CrmPage.jsx"), "CrmPage");
const LeadInboxPage = lazyNamed(
  () => import("../features/leads/LeadInboxPage.jsx"),
  "LeadInboxPage",
);
const LeadProfileEditor = lazyNamed(
  () => import("../features/leads/LeadProfileEditor.jsx"),
  "LeadProfileEditor",
);
const LoginPage = lazyNamed(() => import("../features/auth/LoginPage.jsx"), "LoginPage");
const MoneyPage = lazyNamed(() => import("../features/money/MoneyPage.jsx"), "MoneyPage");
const NotificationsPage = lazyNamed(
  () => import("../features/notifications/NotificationsPage.jsx"),
  "NotificationsPage",
);
const ProfileSettings = lazyNamed(
  () => import("../features/settings/ProfileSettings.jsx"),
  "ProfileSettings",
);
const ProjectsPage = lazyNamed(
  () => import("../features/projects/ProjectsPage.jsx"),
  "ProjectsPage",
);
const PublicCardPage = lazyNamed(
  () => import("../features/public-profile/PublicCardPage.jsx"),
  "PublicCardPage",
);
const PublicProfilePage = lazyNamed(
  () => import("../features/public-profile/PublicProfilePage.jsx"),
  "PublicProfilePage",
);
const IconLabPage = lazyNamed(() => import("../pages/IconLabPage.jsx"), "IconLabPage");
const VkAuthFinishPage = lazyNamed(
  () => import("../features/auth/VkAuthFinishPage.jsx"),
  "VkAuthFinishPage",
);

export function AppRoutes() {
  return (
    <Suspense fallback={<p className="route-loading" role="status">Открываем раздел…</p>}>
      <Routes>
        <Route path="login" element={<LoginPage />} />
        <Route path="auth/finish" element={<AuthFinishPage />} />
        <Route path="auth/vk/callback" element={<VkAuthFinishPage />} />
        <Route path="p/:slug" element={<PublicCardPage />} />
        <Route element={<ProtectedRoute />}>
          <Route element={<WorkspaceTimeZoneProvider><AppShell /></WorkspaceTimeZoneProvider>}>
            <Route index element={<TodayPage />} />
            <Route path="today" element={<TodayPage />} />
            <Route
              path="onboarding"
              element={<Navigate replace to="/?onboarding=1" />}
            />
            <Route path="leads" element={<LeadInboxPage />} />
            <Route path="leads/settings" element={<LeadProfileEditor />} />
            <Route path="crm" element={<CrmPage />} />
            <Route path="projects" element={<ProjectsPage />} />
            <Route path="money" element={<MoneyPage />} />
            <Route path="notifications" element={<NotificationsPage />} />
            <Route path="profile" element={<PublicProfilePage />} />
            <Route path="analytics" element={<AnalyticsPage />} />
            <Route path="settings" element={<ProfileSettings />} />
            <Route path="settings/plan" element={<BillingPlanPage />} />
            <Route path="icon-lab" element={<IconLabPage />} />
            <Route path="*" element={<Navigate replace to="/" />} />
          </Route>
        </Route>
      </Routes>
    </Suspense>
  );
}
